<template>
    <div class="message-action p-relative" v-if="isVisible" :class="message.mtype">
        <ActionDefaultLayout v-if="useDefaultLayout" :message="message">
            <component :is="componentByMessageType" :message="message" />
        </ActionDefaultLayout>
        <component v-else :is="componentByMessageType" :message="message" />
    </div>
</template>
<script>
import ActionDefaultLayout from './ActionDefaultLayout'

export default {
    name: 'MessageAction',
    props: ['message'],
    components: {
        ActionDefaultLayout,
        ActionContactDone: () => import('./message-actions/ActionContactDone'),
        ActionContactRequest: () => import('./message-actions/ActionContactRequest'),
        ActionOpenChat: () => import('./message-actions/ActionOpenChat'),
        // ActionShare: () => import('./message-actions/ActionShare'),
        ActionShareDone: () => import('./message-actions/ActionShareDone'),
        ActionShareRequest: () => import('./message-actions/ActionShareRequest'),
        ActionRecommendRequest: () => import('./message-actions/ActionRecommendRequest'),
        ActionRecommendAccept: () => import('./message-actions/ActionRecommendAccept'),
        ActionRecommendReject: () => import('./message-actions/ActionRecommendReject'),
        ActionNoti: () => import('./message-actions/ActionNoti'),
        ActionAlimiBasic: () => import('./message-actions/ActionAlimiBasic'),
        ActionPhoto: () => import('./message-actions/ActionPhoto'),
        ActionGiftInfo: () => import('./message-actions/ActionGiftInfo'),
        ActionRefundStatus: () => import('./message-actions/ActionRefundStatus'),
        ActionPremiumStart: () => import('./message-actions/ActionPremiumStart'),
        ActionPremiumChat: () => import('./message-actions/ActionPremiumChat'),
        ActionPremiumSurveyEnd: () => import('./message-actions/ActionPremiumSurveyEnd'),
        ActionPremiumRating: () => import('./message-actions/ActionPremiumRating'),
    },
    computed: {
        content() {
            return this.$mustParse(this.message.content)
        },
        componentByMessageType() {
            if (this.message.mtype.includes('noti')) return 'ActionNoti'
            if (this.message.mtype.includes('photo')) return 'ActionPhoto'
            if (this.message.mtype === 'premium-survey-end') return 'ActionPremiumSurveyEnd'
            // if (this.message.mtype === 'premium-rating') return 'ActionPremiumRating'

            return 'Action' + this.$options.filters.toPascal(this.message.mtype, '-', 2)
        },
        useDefaultLayout() {
            return ['alimi', 'photo', 'gift-info'].every(key => !this.message.mtype.includes(key))
        },
        isVisible() {
            if (['refund-status-user'].indexOf(this.message.mtype) !== -1) return false

            return true
        },
    },
}
</script>
